// extracted by mini-css-extract-plugin
export default {"errorContent":"style_errorContent__I48YB"};